const GET_DATA_FROM_API = 'GET_DATA_FROM_API';
const ASYNC_FETCH = 'ASYNC_FETCH';
const ASYNC_FETCH_SUCCESS = 'ASYNC_FETCH_SUCCESS';
const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS';
const ERR_OCCURED = 'ERR_OCCURED';
const SHOW_ORDERCONFIRMATION_CART = 'SHOW_ORDERCONFIRMATION_CART';
const SUBMIT_ORDER = 'SUBMIT_ORDER';
const GET_PROMO = 'GET_PROMO';
const GET_PROMO_SUCCESS = 'GET_PROMO_SUCCESS';
const GET_CONFIRMSALE_SUCCESS = 'GET_CONFIRMSALE_SUCCESS';
export const GET_CART_DETAILS_CONFIRMATION = 'GET_CART_DETAILS_CONFIRMATION';
const GET_CONFIRMSALE = 'GET_CONFIRMSALE';
export const DEFAULT_ERR_MSG = 'We are unable to process the request at this time. Please try after sometime';
const SHOW_CONFIRMATION_API_ERROR = 'SHOW_CONFIRMATION_API_ERROR';
const CEF_ORDER_CONFIRMATION_ERROR = 'CEF_ORDER_CONFIRMATION_ERROR';
const DEFAULT_ERROR_MESSAGE = 'Looks like something went wrong. Please try again later.';
export {
  GET_DATA_FROM_API,
  ASYNC_FETCH,
  ASYNC_FETCH_SUCCESS,
  GET_DATA_SUCCESS,
  ERR_OCCURED,
  SHOW_ORDERCONFIRMATION_CART,
  GET_PROMO,
  SUBMIT_ORDER,
  GET_PROMO_SUCCESS,
  GET_CONFIRMSALE_SUCCESS,
  GET_CONFIRMSALE,
  SHOW_CONFIRMATION_API_ERROR,
  CEF_ORDER_CONFIRMATION_ERROR,
  DEFAULT_ERROR_MESSAGE,
};
